import * as React from 'react';
import { InfoIcon } from '../images/images';

export const InformationIcon = (props: { style?: React.CSSProperties; link: string }) => {
    return (
        <img
            src={InfoIcon}
            style={{ ...styles.icon, ...props.style } as React.CSSProperties}
            onClick={() => window.open(props.link, '_blank')}
        />
    );
};

const styles = {
    icon: {
        height: 32,
        objectFit: 'contain',
        cursor: 'pointer',
    },
};



// WEBPACK FOOTER //
// ./src/SharedComponents/InformationIcon.tsx